module.exports = __webpack_public_path__ + "img/ollipay_logo.d3ea848b.jpg";